module.exports = __webpack_public_path__ + "static/media/nus.f91f1be9.png";